import { buildContactMessage } from './gvode-wishlist-core.js';

const bounded = (value, max) => String(value ?? '').slice(0, max);

export function contextFromSearch(search, origin = window.location.origin) {
  const params = new URLSearchParams(search);
  if (params.get('gvode_source') !== 'sold-out') return null;

  let productUrl = '';
  let variantId = '';
  try {
    const storeOrigin = new URL(origin).origin;
    const url = new URL(params.get('url') ?? '', storeOrigin);
    if (url.origin === storeOrigin && url.pathname.startsWith('/products/')) {
      variantId = bounded(url.searchParams.get('variant'), 40);
      const safeUrl = new URL(url.pathname, storeOrigin);
      if (variantId) safeUrl.searchParams.set('variant', variantId);
      productUrl = `${safeUrl.pathname}${safeUrl.search}`;
    }
  } catch {
    productUrl = '';
    variantId = '';
  }

  return {
    productTitle: bounded(params.get('product'), 240),
    variantTitle: bounded(params.get('variant'), 240),
    sku: bounded(params.get('sku'), 120),
    productUrl,
    variantId,
  };
}

export function prefillContactForm(form, search, origin) {
  if (form.querySelector('.contact-form__success')) return false;

  const context = contextFromSearch(search, origin);
  const body = form.querySelector('textarea[name="contact[body]"]');
  if (!context || !body || body.value.trim() !== '') return false;

  body.value = buildContactMessage(context);
  return true;
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  for (const form of document.querySelectorAll('[data-gvode-contact-form]')) {
    prefillContactForm(form, window.location.search, window.location.origin);
  }
}
